import {store, storeEmitter, INITIAL_DATA} from './store'
import {USER_AUTHORIZED_USER} from "../components/RedbayComponents";




export default {
  init() {
    console.log('init listener');
    storeEmitter.on(INITIAL_DATA, (shop) => {
      store.dispatch('user/setUser', shop.user);
    });

    storeEmitter.on(USER_AUTHORIZED_USER, (user) => {
      if (user) {
        store.dispatch('user/getUserSettings');
        store.dispatch('user/getPrices');
      }
    });


  }


}



// WEBPACK FOOTER //
// ./src/state/listener.js